import { FormControl, RadioGroup, Radio, Flex, Stack, Spinner, FormErrorMessage } from '@chakra-ui/react'
import { PersonDto } from 'BrokerTsLib/src/dtos'
import { SelectionType, Selection } from 'brokertslib/src/enums'
import { useContext } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { FormLabel } from '../components/FormLabel'
import { RadioStack } from '../components/RadioStack'
import { useSelections } from '../hooks'
import { useNameof } from '../hooks/useNameof'
import { Business, Citizen, Company } from '../icons'
import { insuranceParamsContext } from '../layouts/Wizard'

const RadioLabelWithIcon = ({ children }: { children: React.ReactNode }) => {
  return <Flex sx={{ gap: 2, alignItems: 'center' }}>{children}</Flex>
}

export const InsureeType = ({ personPrefix, disabled }: { personPrefix: string, disabled?: boolean }) => {
  const { insuranceParams } = useContext(insuranceParamsContext)
  const isDisabled = !!insuranceParams?.generalParams.contractNumber || disabled

  const pnameof = useNameof<PersonDto>(personPrefix)
  const nameof = useNameof<PersonDto>()
  const { data: dataTypOsoby, isLoading: isLoadingTypOsoby, isFetching: isFetchingTypOsoby } = useSelections(SelectionType.TypOsoby)
  const { control, setValue, getValues, getFieldState } = useFormContext()

  const iconColor = 'gray.500'

  const personIcons = {
    [Selection.Person]: <Citizen color={iconColor} />,
    [Selection.SelfEmployed]: <Business color={iconColor} />,
    [Selection.Company]: <Company color={iconColor} />
  }

  const typeError = getFieldState(pnameof(x => x.type)).error

  return (
    <FormControl isInvalid={!!typeError}>
      <Stack direction={'row'}>
        <FormLabel>Typ</FormLabel>
        {(isFetchingTypOsoby || isLoadingTypOsoby) && <Spinner />}
      </Stack>

      <Controller
        name={pnameof(x => x.type)}
        control={control}
        render={({ field: { onChange, value } }) => (
          <RadioGroup
            onChange={e => {
              var val = parseInt(e)
              switch (val) {
                case Selection.Person:
                  setValue(pnameof(x => x.companyName), null)
                  setValue(pnameof(x => x.idendificationNumber), null)
                  break;

                case Selection.Company:
                  setValue(pnameof(x => x.name), null)
                  setValue(pnameof(x => x.surname), null)
                  setValue(pnameof(x => x.birthNumber), null)
                  setValue(pnameof(x => x.birthday), null)
                  setValue(pnameof(x => x.isForeigner), false)
                  setValue(pnameof(x => x.nationalityId), null)
                  break;
              }

              onChange(val)
            }}
            value={value?.toString() ?? ''}
            isDisabled={isDisabled}
          >
            <RadioStack variant="tile">
              {dataTypOsoby?.data.map((item) => (
                <Radio value={item.id.toString()} key={item.id}>
                  <RadioLabelWithIcon>
                    {item.description}
                    {(personIcons as any)[item.id]}
                  </RadioLabelWithIcon>
                </Radio>
              ))}
            </RadioStack>

          </RadioGroup>
        )}
      />

      {typeError && <FormErrorMessage>{typeError.message}</FormErrorMessage>}
    </FormControl>
  )
}
